module.exports = __webpack_public_path__ + "static/media/a77f80ae-abcf-401e-9cb3-ab84498fc03b.e0373294.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274163/a77f80ae-abcf-401e-9cb3-ab84498fc03b.woff
// module id = 1672
// module chunks = 2